import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';
const CancelToken = axiosInstance.CancelToken;

export const getLossAndDamageClaimsStatusEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimStatus`,
    method: 'get',
  });
};

export const getLossAndDamageClaimsListBasicEffect = (params) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetBasicClaimSearch`,
    method: 'get',
    params,
  });
};

export const getLossAndDamageClaimsListAdvancedEffect = (params) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetAdvancedClaimSearch`,
    method: 'get',
    params,
  });
};

export const getLADDivisionListEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetDivision`,
    method: 'get',
  });
};

export const getLADRegionListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetRegion`,
    method: 'get',
    params,
  });
};

export const getLADBranchByDivisionRegionListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetBranchByDivisionRegion`,
    method: 'get',
    params,
  });
};

export const getLADProcessorListEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimProcessor`,
    method: 'get',
  });
};

export const getLADSortingFieldsListEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetSortColumns`,
    method: 'get',
  });
};

export const deleteLADClaimsEffect = (ClaimKeys) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/DeleteClaim`,
    method: 'delete',
    params: { ClaimKeys },
  });
};

export const getLADClaimDetailsEffect = (ClaimKey) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaim`,
    method: 'get',
    params: { ClaimKey },
  });
};

export const getLADClaimsListForExportExcelEffect = (params) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimDataForPrintResult`,
    method: 'get',
    params,
  });
};

export const saveLADClaimEffect = (data) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/SaveClaim`,
    method: 'post',
    data,
  });
};

export const getLADClaimsChargeCodesEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetChargeCode`,
    method: 'get',
  });
};

export const getClaimCommodityCodeListEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetCommodityCode`,
    method: 'get',
  });
};

export const getClaimLidLabelListEffect = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetLidLabel`,
    method: 'get',
  });
};

export const sendLDClaimEmailToCarrierEffect = (data) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/SendMailToTransportationProvider`,
    method: 'post',
    data,
  });
};

export const getLDCarrierInfoEffect = (CarrierKey) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetCarrierInfo`,
    method: 'get',
    params: { CarrierKey },
  });
};

export const checkLDClaimXpoExportEffect = (ClaimKey) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/isXPOCarrier`,
    method: 'get',
    params: { ClaimKey },
  });
};

export const sendLDClaimEmailToXpoCarrierEffect = (data) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/ExportToXpo`,
    method: 'post',
    data,
  });
};

export const getLDClaimTableViewColumn = (GridName = 'LossAndDamageClaims') => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetGridColumnOptions`,
    method: 'get',
    params: { GridName: GridName },
  });
};

export const saveLDClaimTableViewColumn = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/SaveGridColumnOption`,
    method: 'post',
    data,
  });
};

let checkDuplicateLDClaimEffectCancelToken = () => {};
export const checkDuplicateLDClaimEffect = (params) => {
  checkDuplicateLDClaimEffectCancelToken();
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/CheckDuplicateClaim`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      checkDuplicateLDClaimEffectCancelToken = c;
    }),
  });
};

export const getLADClaimNotesEffect = ({
  claimKey,
  pageIndex,
  sortColumn = 'SequenceNo',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimComment`,
    method: 'get',
    params: {
      claimKey,
      pageIndex,
      sortColumn,
      sortDirection,
      pageSize,
    },
  });
};

export const getLADClaimSettlementsEffect = ({
  claimKey,
  pageIndex,
  sortColumn = 'SettlementSeq',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimSettlement`,
    method: 'get',
    params: {
      claimKey,
      pageIndex,
      sortColumn,
      sortDirection,
      pageSize,
    },
  });
};

export const getLADClaimItemsEffect = ({
  claimKey,
  pageIndex,
  sortColumn = 'itemSeq',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimItem`,
    method: 'get',
    params: {
      claimKey,
      pageIndex,
      sortColumn,
      sortDirection,
      pageSize,
    },
  });
};

export const getLADClaimEmailStatusEffect = ({ claimKey }) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimEmailNotification`,
    method: 'get',
    params: {
      claimKey,
    },
  });
};

export const getLDClaimFilesEffect = ({
  claimKey,
  pageIndex,
  sortColumn = 'itemSeq',
  sortDirection = 'DESC',
  pageSize = 10,
}) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetClaimFile`,
    method: 'get',
    params: {
      claimKey,
      sortColumn,
      sortDirection,
      pageIndex,
      pageSize,
    },
  });
};
